import type { ViewPagePersonalizationQuery$variables } from './queries/__generated__/ViewPagePersonalizationQuery.graphql.ts';

export type PersonalizationGroups = {
	loom?: { includeMeetingRecorderEligibility: boolean };
	recommendations?: { experience: string };
	onboarding?: { keys: ReadonlyArray<string> };
	omnibar?: { keys: ReadonlyArray<string> };
	catchup?: boolean;
	presence?: boolean;
};

/** Shared by SSR and client route loading. Excluded fields never receive real service arguments. */
export function buildViewPagePersonalizationVariables(
	{
		cloudId,
		contentId,
		spaceKey,
		isBlog,
	}: {
		cloudId: string;
		contentId: string;
		spaceKey: string;
		isBlog: boolean;
	},
	groups: PersonalizationGroups,
): ViewPagePersonalizationQuery$variables {
	return {
		cloudId,
		contentId,
		spaceKey,
		includeLoom: !!groups.loom,
		includeMeetingRecorderEligibility: groups.loom?.includeMeetingRecorderEligibility ?? false,
		includeRecommendations: !!groups.recommendations,
		recommendationEntityType: groups.recommendations ? (isBlog ? 'blogpost' : 'page') : '',
		recommendationExperience: groups.recommendations?.experience ?? '',
		// The legacy space-status query takes the space key, despite the scaffold variable's name.
		recommendationSpaceId: groups.recommendations ? spaceKey : '',
		includeOnboardingState: !!groups.onboarding,
		onboardingKeys: groups.onboarding?.keys,
		includeOmnibarOnboardingState: !!groups.omnibar,
		omnibarOnboardingKeys: groups.omnibar?.keys,
		includeAIFloatingContextMenu: !!groups.catchup,
		catchupContentType: groups.catchup && isBlog ? 'BLOGPOST' : 'PAGE',
		includePresenceSettings: !!groups.presence,
	};
}
